import { 
  createRouter,
  createWebHashHistory,
  createWebHistory,
  Router,
  RouteRecordRaw,
} from "vue-router";
import swal from "sweetalert";

let router: Router;
let routeGuard: boolean;

const RouterService = {
  initialise(props: any) {
    routeGuard = false;
    const routes = this.getRoutes(props.routes);
    const newRouter = createRouter({
      history: props.hashHistory ? createWebHashHistory(props.baseURL) : createWebHistory(props.baseURL),
      routes: routes,
    });
    console.log("Application Routes: ", JSON.stringify(routes, null, 4));
    console.log("Application Base URL: ", props.baseURL);
    router = newRouter;
    router.beforeEach((to, from, next) => {
      const { path } = to;
      if (routeGuard) {
        swal({
          title: "Important",
          text: "Are you sure you want to leave the page? Any changes you have made will be lost.",
          buttons: ["Cancel", "Continue"],
        }).then((proceed) => {
          if (proceed) {
            routeGuard = false;
            console.log("Router re-directing to: ", path);
            next();
          }
        });
      } else {
        console.log("Router re-directing to: ", path);
        next();
      }
    });
  },
  getRoutes(routes: any) {
    const productionRoutes: Array<RouteRecordRaw> = [
      {
        path: routes.fulfilment,
        name: "fulfilment",
        component: () => import("@/features/fulfilment/FulfilmentPage.vue"),
      },
      {
        path: routes.unlinked,
        name: "unlinked",
        component: () => import("@/features/cashless/UnlinkedAccounts/UnlinkedAccountsPage.vue"),
      },
      // The okta login requires this callback url to store the token. This api is handed by OktaAuthJS.
      // In the router if we don't redirect, then the menu will attempt to load /auth/callback/fullfillment which doesn't work.
      {
        path: "/auth/callback",
        redirect: "/",
      },
      // Uncomment to load the contact book demo app. 
      // {
      //   path: "/demo",
      //   name: "Demo",
      //   component: () => import("@/features/contactBook/ContactBookDemo.vue"),
      // },
    ];
    return productionRoutes;
  },
  getRouter() {
    return router;
  },
  setRouteGuard(value: boolean) {
    routeGuard = value;
  },
  getRouteGuard(): boolean {
    return routeGuard;
  },
};

export default RouterService;
